import { ArrowBackIosNew } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import { useHistory } from "react-router-dom";
import { IconButton } from "@mui/material";
import * as s from "./styles";

interface IPageHeader {
  label: React.ReactNode;
  handleBackPress?: () => void;
  children?: React.ReactNode;
}

export default function PageHeader(props: IPageHeader) {
  const history = useHistory();
  const { handleBackPress = () => history.push("/") } = props;

  return (
    <s.PageHeaderContainer>
      <IconButton
        size="large"
        sx={{ position: "absolute", marginLeft: "1.3rem" }}
        onClick={handleBackPress}
      >
        <ArrowBackIosNew sx={{ fontSize: "1.2rem" }} />
      </IconButton>
      <Typography
        gutterBottom
        variant="body1"
        sx={{ ml: "4.5rem", mt: "0.6rem" }}
      >
        {props.label}
      </Typography>
      {props.children}
    </s.PageHeaderContainer>
  );
}
